module.exports = __webpack_public_path__ + "img/asus-zenbook-ux434.b8e5f47e.jpg";